import React from "react";
import PropTypes from "prop-types";
import { FaAngleLeft } from "react-icons/fa";

const ButtonPrev = ({
  onClick,
  className = "",
  icon = <FaAngleLeft />,
  style = {},
  size = 35,
  iconSize = "text-4xl",
  color = "bg-[#14532D]",
  hoverColor = "hover:bg-[#1E6938]",
}) => {
  return (
    <button
      className={`absolute ${color} text-white border-0 rounded-full flex justify-center items-center z-20 shadow-[0_0rem_2rem_rgba(0,0,0,0.3)] pr-[3px] ${hoverColor} ${iconSize} ${className}`}
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      {icon}
    </button>
  );
};

ButtonPrev.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.object,
  size: PropTypes.number,
  iconSize: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
};

export default ButtonPrev;
